import axios from './axiosConfig';

const API_URL = '/games/';

const generateGamesForGroup = async (groupId, stageId) => { // OK
    return axios.post(API_URL + groupId + '/generate-games', { stageId });
};

const generateGamesForStage = async (stageId) => {
    return axios.post(API_URL + 'generate-games-for-stage/' + stageId);
};

const getGamesForGroup = async (groupId) => { // OK
    return axios.get(API_URL + 'group/' + groupId);
};

const deleteGamesForGroup = async (groupId) => { // OK
    return axios.delete(API_URL + groupId + '/delete-games');
};

const updateGame = (gameId, gameData) => {
    return axios.put(API_URL + gameId, gameData);
};

const getPlayerGames = (stageId) => { // OK
    return axios.get(API_URL + 'player-games/' + stageId);
};

const getPlayerGamesByPlayerId = (stageId, playerId) => {
    return axios.get(API_URL + 'player-games/' + stageId + '/' + playerId);
};

const getGamesForStage = async(stageId) => {
    return axios.get(API_URL + 'stage/' + stageId);
};

const updateStatistics = async(gameId,resetInDTO) => {
    const response =  await axios.put(API_URL + 'update-statistics/' + gameId, resetInDTO);
    return response.data;
};

export default {
    generateGamesForGroup,
    getGamesForGroup,
    deleteGamesForGroup,
    updateGame,
    getPlayerGames,
    getPlayerGamesByPlayerId,
    generateGamesForStage,
    getGamesForStage,
    updateStatistics,
};